// extracted by mini-css-extract-plugin
export default {"subheader":"ofVXBo7Ek2Y8gxPFmXkZ"};